import { render, staticRenderFns } from "./ScalesManage.vue?vue&type=template&id=f1799a6a&scoped=true"
import script from "./ScalesManage.vue?vue&type=script&lang=js"
export * from "./ScalesManage.vue?vue&type=script&lang=js"
import style0 from "./ScalesManage.vue?vue&type=style&index=0&id=f1799a6a&prod&scoped=true&lang=css"
import style1 from "./ScalesManage.vue?vue&type=style&index=1&id=f1799a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1799a6a",
  null
  
)

export default component.exports